import { render, staticRenderFns } from "./get-app.vue?vue&type=template&id=6a6e232c&"
import script from "./get-app.vue?vue&type=script&lang=js&"
export * from "./get-app.vue?vue&type=script&lang=js&"
import style0 from "./get-app.vue?vue&type=style&index=0&id=6a6e232c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports